import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-xs md:text-sm text-foreground-500">
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((item, index) => (
          <li key={item.label} className="flex items-center gap-2">
            {item.to ? (
              <Link to={item.to} className="hover:text-primary-500 transition-colors cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800">{item.label}</span>
            )}
            {index < items.length - 1 && <i className="ri-arrow-right-s-line text-foreground-400" />}
          </li>
        ))}
      </ol>
    </nav>
  );
}